import React from 'react';
import { HelmetDatoCms } from 'gatsby-source-datocms';
import { graphql } from 'gatsby';
import HubspotForm from 'react-hubspot-form';
import { chakra, Box } from '@chakra-ui/react';

import Section from '../components/ui/Section';
import ComponentWrapper from '../components/ui/ComponentWrapper';
import Header from '../components/ui/Header';
import { H3 } from '../components/styles/HeadingStyles';

const PageContent = chakra('div', {
  baseStyle: {
    h2: {
      lineHeight: ['3', '7'],
      mb: ['1', '4'],
      fontSize: ['3', '7'],
      fontWeight: ['3'],
      pb: '6',
      maxWidth: ['100%', '90%'],
    },
    p: {
      pb: '6',
      fontSize: '2',
      maxWidth: ['100%', '100%'],
    },
  },
});

const HubspotFormBox = chakra(Box, {
  baseStyle: {
    p: {
      pb: ['2', '4'],
    },
  },
});

type Props = {
  data: {
    datoCmsLandingPage: {
      seoMetaTags: {
        id: string;
        children: any[];
        parent: any;
        tags: any[];
      };
      title: string;
      body: string;
      extraText: string;
      addExtraText: boolean;
      subtitle: string;
      formId?: string;
      webinarTime?: Date;
    };
  };
};
// Was intended to be used for marketing landing pages. We have not developed these yet.
const LandingPagesTemplate = ({ data }: Props) => {
  const {
    seoMetaTags,
    title,
    body,
    subtitle,
    extraText,
    addExtraText,
    formId,
    webinarTime,
  } = data.datoCmsLandingPage;
  // const image = headerImage || {};

  const dateAndTime = new Intl.DateTimeFormat('en-GB', {
    dateStyle: 'full',
    timeStyle: 'long',
  }).format(new Date(webinarTime));

  return (
    <>
      <HelmetDatoCms seo={seoMetaTags} />

      <Header
        title={title}
        subTitle={webinarTime && dateAndTime}
        pb={[4, 8]}
        image={false}
      />
      <Section py={[8, 32]} bg="lightGrey">
        <ComponentWrapper mb={[16, 32]} mx="auto" maxWidth={['maxWidth']}>
          <Box width="maxWidth">
            <H3 mb={[7, 16]}>{subtitle}</H3>
            {addExtraText ? (
              <PageContent
                pb={['2', '4']}
                dangerouslySetInnerHTML={{ __html: extraText }}
              />
            ) : null}
          </Box>
          <Box width={['100%', '50%']} pr={7}>
            <PageContent dangerouslySetInnerHTML={{ __html: body }} />
          </Box>
          <HubspotFormBox as="aside" width={['100%', '50%']} mb={[4]}>
            <HubspotForm
              portalId="4330484"
              formId={formId}
              onSubmit={() => {}}
              onReady={(_: any) => {}}
              loading={<div>Loading...</div>}
            />
          </HubspotFormBox>
        </ComponentWrapper>
      </Section>
    </>
  );
};

export default LandingPagesTemplate;

export const query = graphql`
  query LandingPageQuery($slug: String!) {
    datoCmsLandingPage(slug: { eq: $slug }) {
      title
      subtitle
      body
      extraText
      addExtraText
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      leadFormType
      cta

      downloadableAsset {
        url
        filename
        title
      }
      headerImage {
        alt
        gatsbyImageData(
          width: 500
          height: 500
          # layout: CONSTRAINED
          placeholder: BLURRED
          forceBlurhash: false
          imgixParams: { fm: "jpg", auto: "compress" }
        )
        fluid(
          maxWidth: 500
          maxHeight: 500
          imgixParams: { fm: "jpg", auto: "compress" }
        ) {
          ...GatsbyDatoCmsFluid
        }
      }
      formId
      webinarTime
    }
  }
`;
